<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">角色管理</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">

          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
              <FormItem label="角色名称" prop="name">
                  <Input v-model="formValidate.name" placeholder="角色名称"></Input>
              </FormItem>
              <FormItem label="备注" >
                  <Input  v-model="formValidate.info"  placeholder="备注"></Input>
              </FormItem>
          </Form>

          <div class="roleAddContent">
            <div class="roleAddLeft">
              <div class="roleAddTitle">
              <Icon type="ios-paper"></Icon>
              功能权限
              </div>
              <div class="roleTreeContent">
                <tree-menu 
               :deptData="MenuLists"
               :selectedId = "selectedMenu" 
                v-on:getMenusTree = 'getMenusTree'
                ></tree-menu> 
              </div>
              

            </div>
            <div class="roleAddRight">
              <div class="roleAddTitle">
              <Icon type="soup-can"></Icon>
              数据权限
              </div>
              <div class="roleTreeContent">
                 <tree-com 
                 :deptData = "deptLists" 
                 :selectedId = "selectedDept" 
                 v-on:getTree = 'getDeptNodes'
                  ></tree-com> 
              </div>

            </div>
          </div>

          <div class="butBox">
             <Button type="primary" @click="handleSubmit('formValidate')"   >确定</Button>
              <i-button type="primary" @click="$router.push({ name: 'Role' })" style="margin-left:5px;">返回</i-button>
          </div>
          

        </div>
      </div>


    </div>
  
   
  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
  // .ivu-modal-footer{
  //   text-align:center !important;
  // }
  .ivu-form-item{
    width: 33%;
    display: inline-block;
  }
  .roleAddContent{
    width:100%;
    margin:0 auto;
    // overflow:hidden;
    display:flex;
  }
  .roleAddLeft,.roleAddRight{
    flex:1;
    border:solid 1px #c9c9c9;
    border-radius:5px;
    max-height: 500px;
    overflow: scroll;
  }
  .roleAddLeft{
    margin-right:20px;
  }
  .roleAddTitle{
    width:100%;
    height:40px;
    line-height:40px;
    border-radius:5px 5px 0 0;
    padding:0 15px;
    font-size:16px;
    background:rgb(230,235,240);
  }
  .roleAddTitle i{
    margin-right:8px;
    font-size:16px;
  }
  .roleTreeContent{
    padding:15px;
  }
.butBox{
  width:100%;
  text-align:center;
  margin-top:30px;
  padding:20px;
}
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  import treeCom from '../../components/tree'
  import treeMenu from '../../components/menuTree'
  // import dateformat from '../../util/dateformat' 

  // import api from '../../api/commonApi'
  export default{
    data(){
      return {
        menuData:[],
        modalDept:false,
        // treeNode:'所属部门',
        activeName:'',
        treeNodeId:'',
        MenuLists:[],
        deptLists:[],
        menuIdList:[],
        deptIdList:[],
        selectedDept:[],
        selectedMenu:[],
        activeName:'',
        formValidate: {
            name: '',
            info:''
        },
        ruleValidate: {
            name: [
                { required: true, message: '角色名称不能为空', trigger: 'blur' }
            ],
        },
      
      }
    },
    mounted:function(){  
         console.log(this.$route.params)

        // var activeName = this.$route.params.activeName;
        // localStorage.setItem('activeName',JSON.stringify(activeName));
        this.activeName = this.$route.params.activeName;
       

        // 新增初始化页面数据
        if(this.activeName == "新增"){
          this.formValidate.name = '';
          this.formValidate.info = '';
          this.menuIdList = [];
          this.deptIdList = [];

        }else if(this.activeName == "修改"){
          this.formValidate.name = this.$route.params.currList.roleName;
          this.formValidate.info = this.$route.params.currList.remark;
          this.selectedDept = [];
          this.selectedMenu = [];
          if(this.$route.params.currList.deptList.length !== 0){
            this.selectedDept.push(this.$route.params.currList.deptList[0].deptId);
            this.selectedMenu.push(this.$route.params.currList.deptList[0].deptId);
          }
          
        }

        this.getDepartment();
        this.getMenu()
        
    },
    methods: {
        getMenu:function(){
           api.Menu.getLists({

            }, resp => {
              // console.log(resp)
              this.MenuLists = resp.menuList;
              // console.log(this.MenuLists)
            }, error => {
              
            })
        },
        getDepartment:function(){
          api.Dept.getData({

            }, resp => {
              // console.log(resp)
              this.deptLists = resp.deptList;
              // console.log(this.deptLists)
            }, error => {
              
            })
        },
        getMenusTree:function(tree){
             this.menuIdList = [];
             var obj = [];
             console.log(tree)
             console.log(this.menuIdList)
             console.log(obj)

            // this.menuIdList = tree;
            var len  = tree.length;
            for(var i=0;i<len;i++){
              obj.push(tree[i])
            }
            console.log(obj)
            this.menuIdList = obj
            console.log(this.menuIdList)
            // this.treeNodeId = tree.deptId;

        },
        getDeptNodes:function(tree){
            console.log(tree);
            this.deptIdList = tree.deptId;
            console.log(this.deptIdList)
            // this.treeNode = "";
            // for(var i=0;i<tree.name.length;i++){
            //   this.treeNode += tree.name[i]
            // }
            // this.treeNodeId = tree.depeId;

        },
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
              console.log(valid)
              console.log(this.menuIdList)
              console.log(this.deptIdList)
                if (valid) {


                  if(this.menuIdList.length == 0){
                    // console.log('请选择功能权限')
                    this.$Message.error('请选择功能权限!');
                    return false;
                  }
                  if(this.deptIdList.length == 0){
                    this.$Message.error('请选择数据权限!');
                    // console.log('请选择数据权限')
                    return  false;
                  }
                  console.log(this.activeName)
                  if(this.activeName == "修改"){
                    api.Role.updateRole({
                      "rolrId":this.$route.params.roleId,
                      "roleName": this.formValidate.name,
                      "menuIdList": this.menuIdList,
                      "deptIdList": this.deptIdList,
                    }, resp => {
                      // console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('修改成功!');
                        this.addModel = false;
                        this.$router.push({ name: 'Role' })
                      }else {
                          this.$Message.error('修改失败：'+ resp.msg);
                      }

                    }, error => {

                    })
                  }else if(this.activeName == "新增"){
                    console.log(this.menuIdList)
                    console.log(this.deptIdList)
                    
                    api.Role.addRole({
                      "roleName": this.formValidate.name,
                      "menuIdList": this.menuIdList,
                      "deptIdList": this.deptIdList,
                    }, resp => {
                      console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('新增成功!');
                        this.addModel = false;
                        this.$router.push({ name: 'Role' })
                      }else {
                          this.$Message.error('新增失败：'+ resp.msg);
                      }
                      

                    }, error => {

                    })
                  }
                  
                    
                } else {
                    this.$Message.error('Fail!');
                }
            })
           

        },

    },

      components: {treeCom,treeMenu}
    }
</script>



// WEBPACK FOOTER //
// roleAdd.vue?b645ff96